export enum TipoDocumento {
    LiquidacionSueldo = 'Liquidación',
    CertificadoAfp = 'Certificado de AFP',
    PadronAutomovil = 'Padron Automovil',
    Otros = 'Otros'
}